module.exports = __webpack_public_path__ + "static/Action-Column-be86d147613f443f99df35be434081b7.png";